module.exports = __webpack_public_path__ + "static/media/aaron.48e52e68.jpg";